export function getStreetAddress(fullAddress) {
  const splitAddress = fullAddress.split(',');
  return splitAddress ? splitAddress[0] : fullAddress;
}
